import LoadingSkeletonUntyped from "@shared/LoadingSkeleton";
import type { ReactElement } from "react";
import { RESULTS_PAGE_SIZE } from "../constants";

const LoadingSkeleton = LoadingSkeletonUntyped as unknown as (props: Record<string, unknown>) => ReactElement;

const DEFAULT_SKELETON_ROWS = 8;

type MatchResultsSkeletonProps = {
  rowCount?: number;
};

const MatchResultsSkeleton = ({ rowCount }: MatchResultsSkeletonProps = {}) => (
  <div className="tw-overflow-x-auto tw-mx-auto tw-max-w-[1336px]">
    <table className="tw-w-full tw-table-fixed tw-border-collapse tw-text-sm">
      <thead>
        <tr className="tw-border-y tw-border-table-border tw-bg-gray-50">
          <th className="tw-px-3 tw-py-3 tw-text-left tw-font-medium tw-text-gray-900">Uploaded company</th>
          <th className="tw-px-3 tw-py-3 tw-text-left tw-font-medium tw-text-gray-900">Matched against</th>
          <th className="tw-w-24 tw-px-3 tw-py-3 tw-text-left tw-font-medium tw-text-gray-900">Confidence</th>
          <th className="tw-w-48 tw-px-3 tw-py-3 tw-text-left tw-font-medium tw-text-gray-900">Review</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: Math.min(rowCount || DEFAULT_SKELETON_ROWS, RESULTS_PAGE_SIZE) }, (_, index) => (
          <tr key={index} className="tw-border-b tw-border-table-border">
            <td className="tw-px-3 tw-py-4">
              <LoadingSkeleton width="60%" height="14px" />
              <div className="tw-mt-2">
                <LoadingSkeleton width="35%" height="12px" />
              </div>
            </td>
            <td className="tw-px-3 tw-py-4">
              <LoadingSkeleton width="55%" height="14px" />
              <div className="tw-mt-2">
                <LoadingSkeleton width="30%" height="12px" />
              </div>
            </td>
            <td className="tw-px-3 tw-py-4">
              <div className="tw-w-12">
                <LoadingSkeleton width="100%" height="22px" />
              </div>
            </td>
            <td className="tw-px-3 tw-py-4">
              <LoadingSkeleton width="70%" height="14px" />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default MatchResultsSkeleton;
